import UomAPI from './uom.api'

export default UomAPI